import { render, staticRenderFns } from "./DentPush9001.vue?vue&type=template&id=464ef978&scoped=true&"
import script from "./DentPush9001.vue?vue&type=script&lang=js&"
export * from "./DentPush9001.vue?vue&type=script&lang=js&"
import style0 from "./DentPush9001.vue?vue&type=style&index=0&id=464ef978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ef978",
  null
  
)

export default component.exports